import { render, staticRenderFns } from "./IdentityInfoCell.vue?vue&type=template&id=303a5698&scoped=true&"
import script from "./IdentityInfoCell.vue?vue&type=script&lang=ts&"
export * from "./IdentityInfoCell.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityInfoCell.vue?vue&type=style&index=0&id=303a5698&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a5698",
  null
  
)

export default component.exports